import { createSlice } from "@reduxjs/toolkit";

const impersonationSlice = createSlice({
  name: "impersonation",
  initialState: {
    companyId: null,
  },
  reducers: {
    setImpersonatedCompany: (state, action) => {
      state.companyId = action.payload;
    },
    clearImpersonatedCompany: (state) => {
      state.companyId = null;
    },
  },
});

export const {
  setImpersonatedCompany,
  clearImpersonatedCompany,
} = impersonationSlice.actions;

export const selectImpersonatedCompanyId = (state) =>
  state.impersonation?.companyId;

export default impersonationSlice;
